// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import PersonalDataComponent from '../../components/profile/personal-data/personal-data';
import BallotDataComponent from '../../components/profile/ballot-data/ballot-data';
import QualificationDataComponent from '../../components/profile/qualification-data/qualification-data';
import ProfessionalDataComponent from '../../components/profile/professional-data/professional-data';
import OtherDataComponent from '../../components/profile/other-data/other-data';
import DocumentationDataComponent from '../../components/profile/documentation-data/documentation-data';
import InterestAreasDataComponent from '../../components/profile/interest-areas-data/interest-areas-data';

// Primereact imports
import { TabMenu } from 'primereact/tabmenu';

// Styling
import './profile.scss';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import { getAssociateData } from '../../redux/actions/profile';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';
import { isMobileOnly } from 'react-device-detect';

class ProfilePage extends Component {

    constructor(props) {
        super(props);
        this.state = {  
            tabIndex: 0,
            tabMenuItems: [
                { label: this.props.t('profile.areas.personal.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 0}) },
                { label: isMobileOnly ? this.props.t('profile.areas.ballot.title-mobile') : this.props.t('profile.areas.ballot.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 1}) },
                { label: this.props.t('profile.areas.qualification.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 2}) },
                { label: this.props.t('profile.areas.professional.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 3}) },
                { label: this.props.t('profile.areas.other.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 4}) },
                { label: this.props.t('profile.areas.documents.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 5}) },
                { label: this.props.t('profile.areas.interest-areas.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 6}) }
            ]
        };
    }

    componentDidMount() {
        this.props.getAssociateData(this.props.registrationRef);
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            this.setState({
                tabMenuItems: [
                    { label: this.props.t('profile.areas.personal.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 0}) },
                    { label: isMobileOnly ? this.props.t('profile.areas.ballot.title-mobile') : this.props.t('profile.areas.ballot.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 1}) },
                    { label: this.props.t('profile.areas.qualification.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 2}) },
                    { label: this.props.t('profile.areas.professional.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 3}) },
                    { label: this.props.t('profile.areas.other.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 4}) },
                    { label: this.props.t('profile.areas.documents.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 5}) },
                { label: this.props.t('profile.areas.interest-areas.title'), disabled: this.props.editMode, command: () => this.setState({tabIndex: 6}) }
                ]
            });
        }
      }

    setActiveIndex(index) {
        this.setState({tabIndex: index});
    }

    render() {
        return (
            <div>
                <PageTitleComponent title="Os meus dados" />
                {
                    this.props.registrationRef !== null ?
                    <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                        <div className='col-1'></div>
                        <div className='col-10'>
                            <TabMenu model={this.state.tabMenuItems} activeIndex={this.state.tabIndex} onTabChange={(e) => this.setState({tabIndex: e.index})} />
                            { this.state.tabIndex === 0 ? <PersonalDataComponent /> : null }
                            { this.state.tabIndex === 1 ? <BallotDataComponent /> : null }
                            { this.state.tabIndex === 2 ? <QualificationDataComponent /> : null }
                            { this.state.tabIndex === 3 ? <ProfessionalDataComponent /> : null }
                            { this.state.tabIndex === 4 ? <OtherDataComponent /> : null }
                            { this.state.tabIndex === 5 ? <DocumentationDataComponent /> : null }
                            { this.state.tabIndex === 6 ? <InterestAreasDataComponent /> : null }
                        </div>
                        <div className='col-1'></div>
                    </div>
                    : null
                }
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        editMode: state.profile.editMode,
        language: state.profile.language,
        registrationRef: state.authentication.registrationRef
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
      getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(ProfilePage)));